import React, { useState, useEffect } from "react";
import { Wrapper } from "./PaymentExpensesModal.styled";
import { callPostApiWithAuth } from "utils/api";
import { Row, Col, Input, Form, Select_, Button, SuccessNotification } from "components/common";
const PaymentExpensesModal = ({ userData, expenseData, setIsOpen, leadData, getExpenseDataApi, editData }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();

    const data = [
        { name: "Open", id: "1" },
        { name: "Paid", id: "2" },
    ];

    const onFinish = (values) => {
        if (editData?.id) {
            let data = {
                ...values,
                method: "put",
                expenseId: editData?.id,
            };
            setIsLoading(true);
            callPostApiWithAuth("expense", data, onSuccessPostApi, onFailedPostApi);
        } else {
            setIsLoading(true);
            callPostApiWithAuth("expense", values, onSuccessPostApi, onFailedPostApi);
        }
    };

    const onSuccessPostApi = () => {
        SuccessNotification(editData ? "Expense Edit Successfully" : "Expense Created");
        setIsLoading(false);
        form.setFieldValue("invoiceDate", "");
        form.setFieldValue("description", "");
        form.setFieldValue("categoryId", "");
        form.setFieldValue("amount", "");
        form.setFieldValue("status", "");
        form.setFieldValue("leadId", "");
        form.setFieldValue("user", "");
        setIsOpen(false);
        getExpenseDataApi();
    };

    const onFailedPostApi = (err) => {
        setIsLoading(false);
    };

    useEffect(() => {
        if (editData) {
            form.setFieldValue("invoiceDate", editData?.invoiceDate);
            form.setFieldValue("description", editData?.description);
            form.setFieldValue("categoryId", editData?.category);
            form.setFieldValue("amount", editData?.amount);
            form.setFieldValue("status", editData?.status == "open" ? "1" : "2");
            form.setFieldValue("leadId", editData?.leadId);
            form.setFieldValue("user", editData?.userId);
        } else {
            form.setFieldValue("invoiceDate", "");
            form.setFieldValue("description", "");
            form.setFieldValue("categoryId", "");
            form.setFieldValue("amount", "");
            form.setFieldValue("status", "");
            form.setFieldValue("leadId", "");
            form.setFieldValue("user", "");
        }
    }, [editData]);

    return (
        <Wrapper>
            <Form onFinish={onFinish} autoComplete="off" form={form}>
                <Row gutter={[10, 20]} className="">
                    <Col span={24}>
                        <label htmlFor="" className="modal-label">
                            Invoice Date
                        </label>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please select your invoice date",
                                },
                            ]}
                            name="invoiceDate"
                        >
                            <Input type="date" placeholder="Select invoice date" className="modal-input" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <label htmlFor="" className="modal-label">
                            Description
                        </label>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter your description",
                                },
                            ]}
                            name="description"
                        >
                            <Input type="text" placeholder="Enter description" className="modal-input" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <label htmlFor="" className="modal-label">
                            Expense Categories
                        </label>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please choose your expense category ",
                                },
                            ]}
                            name="categoryId"
                        >
                            <Select_ placeholder="Select expense" className="expense-category" options={expenseData} name />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <label htmlFor="" className="modal-label">
                            Amount
                        </label>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter your amount",
                                },
                            ]}
                            name="amount"
                        >
                            <Input type="text" className="modal-input" placeholder="Enter your amount" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <label htmlFor="" className="modal-label">
                            Status
                        </label>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please choose status",
                                },
                            ]}
                            name="status"
                        >
                            <Select_ placeholder="Choose status" options={data} name />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <label htmlFor="" className="modal-label">
                            Lead
                        </label>
                        <Form.Item name="leadId">
                            <Select_
                                placeholder="Please choose user"
                                options={leadData?.map((el) => {
                                    return {
                                        id: el.id,
                                        name: `${el.firstName} ${el.lastName}`,
                                    };
                                })}
                                name
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <label htmlFor="" className="modal-label">
                            User
                        </label>
                        <Form.Item name="user">
                            <Select_
                                placeholder="Select user"
                                options={userData?.map((el) => {
                                    return {
                                        id: el?.objectID,
                                        name: `${el?.name}`,
                                    };
                                })}
                                name
                                // value={userData?.objectID}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Button className="btn-background" title="OK" htmlType="submit" loading={isLoading} />
                    </Col>
                </Row>
            </Form>
        </Wrapper>
    );
};

export default PaymentExpensesModal;
